export const TYPES = {
  FBAnalyticsRepository: Symbol.for('FBAnalyticsRepository'),
  FBAnalyticsUseCases: Symbol.for('FBAnalyticsUseCases'),
};
